import * as Sentry from "@sentry/react";

/**
 * Fallback component displayed when an error is caught.
 * Designed with a premium dark-mode aesthetic.
 */
const FallbackView = ({ error, componentStack, resetError }) => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-black text-white p-6 text-center">
    <div className="bg-neutral-900 border border-neutral-800 p-10 rounded-2xl shadow-2xl max-w-lg w-full">
      <div className="w-16 h-16 bg-red-500/10 text-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
        </svg>
      </div>
      <h1 className="text-3xl font-bold mb-4 tracking-tight">Oops! Something went wrong</h1>
      <p className="text-neutral-400 mb-8 leading-relaxed">
        We've encountered an unexpected error. Our technical team has been automatically notified via Sentry.
      </p>
      <div className="flex flex-col gap-3">
        <button
          onClick={() => {
            resetError();
            window.location.reload();
          }}
          className="w-full py-3 bg-white text-black hover:bg-neutral-200 rounded-xl transition-all font-semibold shadow-lg shadow-white/5"
        >
          Reload Application
        </button>
        <button
          onClick={() => window.history.back()}
          className="w-full py-3 bg-neutral-800 hover:bg-neutral-700 text-neutral-300 rounded-xl transition-all font-medium"
        >
          Go Back
        </button>
      </div>
      {/* Optional: Show feedback dialog trigger */}
      <button 
        onClick={() => Sentry.showReportDialog()}
        className="mt-6 text-sm text-neutral-500 hover:text-white transition-colors"
      >
        Report Feedback
      </button>
    </div>
  </div>
);

const SentryErrorBoundary = ({ children }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={FallbackView}
      showDialog={false} // Trigger manually if needed or set true to auto-show default dialog
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default SentryErrorBoundary;
